import React from 'react';
import styled from 'styled-components';

const TermsKo: React.FC = () => {
  return (
    <>
      <Section>
        <Title>이용약관</Title>
        <Text>
          본 약관은 Architrave(이하 "회사")가 제공하는 서비스의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>제1조 (목적)</SmallTitle>
        <Text>
          이 약관은 회사가 제공하는 SaaS 기반 포트폴리오 서비스 Architrave(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리·의무 및 책임사항, 절차 등을 규정함을 목적으로 합니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>제2조 (정의)</SmallTitle>
        <Text>
          <List2>
            <li>"서비스"란 회원이 작품 이미지와 정보를 업로드하고 이를 기반으로 개인 포트폴리오 웹사이트를 구성 및 운영할 수 있도록 제공되는 웹기반 플랫폼을 의미합니다.</li>
            <li>"회원"이란 회사에 개인정보를 제공하고 서비스에 회원가입한 자를 말합니다.</li>
            <li>"유료회원"이란 정기 결제를 통해 회사가 제공하는 유료 기능을 이용하는 회원을 말합니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제3조 (약관의 게시와 개정)</SmallTitle>
        <Text>
          <List2>
            <li>이 약관은 서비스 초기화면 또는 연결화면에 게시하여 회원이 쉽게 확인할 수 있도록 합니다.</li>
            <li>회사는 관련 법령을 위반하지 않는 범위에서 이 약관을 개정할 수 있으며, 개정 내용과 시행일을 명시하여 최소 7일 전부터 공지합니다. 다만, 회원에게 불리한 변경의 경우 시행일 30일 전부터 공지합니다.</li>
            <li>공지는 서비스 내 게시와 함께 회원이 제공한 연락 수단(이메일 등)을 통해 할 수 있습니다.</li>
            <li>회원이 개정 약관의 시행일까지 이의를 제기하지 않고 서비스를 계속 이용하는 경우, 개정 약관에 동의한 것으로 봅니다.</li>
            <li>회원이 개정 약관에 동의하지 않는 경우 회사 또는 회원은 이용계약을 해지할 수 있으며, 회사는 계약 해지에 따른 별도의 손해배상을 하지 않습니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제4조 (서비스의 제공 및 변경)</SmallTitle>
        <Text>
          <List2>
            <li>회사는 다음의 서비스를 제공합니다:
              <List>
                <li>포트폴리오 웹사이트 생성 및 관리 기능</li>
                <li>이미지 및 작가 정보 업로드 기능</li>
                <li>다운로드 기능 (예: CV, 이미지 파일 등)</li>
              </List>
            </li>
            <li>회사는 서비스의 품질 향상 및 운영상 필요한 경우 서비스 전부 또는 일부를 변경·개선할 수 있으며, 중요한 변경 시 합리적인 방법으로 사전에 고지합니다.</li>
            <li>회사는 운영 또는 정책상의 필요에 따라 서비스의 일부 또는 전부를 중단하거나 종료할 수 있으며, 이 경우 사전에 합리적인 방법으로 고지합니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제5조 (서비스의 중단)</SmallTitle>
        <Text>
          <List2>
            <li>회사는 서비스 안정화를 위해 월 2회 이내, 회당 최대 1시간의 정기 점검을 실시할 수 있습니다.
              해당 정기 점검은 서비스 내 상시 게시된 안내로 사전 고지를 갈음하며, 실제 중단이 없을 수도 있습니다.</li>
            <li>회사는 서비스의 유지보수 또는 보안 취약점 대응 등 긴급한 사유가 있는 경우 서비스를 일시적으로 중단할 수 있으며, 가능한 범위 내에서 사전 또는 사후 통지합니다.</li>
            <li>불가항력(천재지변, 시스템 장애 등)으로 인한 중단 시에는 사전 공지가 불가능할 수 있습니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제6조 (회원가입)</SmallTitle>
        <Text>
          <List2>
            <li>회원가입은 만 14세 이상만 가능하며, 가입 시 해당 사실을 체크하는 절차를 포함합니다.</li>
            <li>이메일 인증을 통해 가입이 완료되며, 소셜 로그인은 제공되지 않습니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제7조 (회원 탈퇴 및 자격 상실 등)</SmallTitle>
        <Text>
          <List2>
            <li>회원은 언제든지 탈퇴할 수 있으며, 탈퇴 시 저장된 데이터는 관련 법령 및 개인정보 처리방침에 따라 삭제됩니다. (단, 관련 법령에 따라 일정 기간 보관이 필요한 정보는 예외로 합니다.)</li>
            <li>회사는 다음과 같은 사유가 있는 경우 사전 통지 후 자격을 제한하거나 상실시킬 수 있습니다:
              <List>
                <li>타인의 정보 도용 또는 사칭</li>
                <li>불법·유해 콘텐츠 업로드</li>
                <li>서비스 운영 방해, 비정상적 이용, 보안 침해 시도</li>
                <li>체험·할인 남용을 위한 다수 계정 생성 등 부정 이용</li>
              </List>
            </li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제8조 (회원에 대한 통지)</SmallTitle>
        <Text>
          <List2>
            <li>회사는 이메일 등 회원이 제공한 연락 수단을 통해 통지하며, 전체 공지의 경우 서비스 내 게시로 갈음할 수 있습니다.</li>
            <li>법적 통지 수신처: 이메일 architrave2025@gmail.com / 우편 (16911) 경기도 용인시 기흥구 마북로 154번길 23 (수신: 법무담당)</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제9조 (유료 서비스 계약의 성립)</SmallTitle>
        <Text>
          <List2>
            <li>유료 서비스 이용계약은 회원의 이용 신청과 결제 완료 시 성립합니다.</li>
            <li>결제 완료 후 즉시 유료 기능 이용이 가능하며, 별도의 승인 절차는 없습니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제10조 (결제방법 및 요금)</SmallTitle>
        <Text>
          <List2>
            <li>결제는 Polar.sh(Stripe 기반) 결제수단만 제공되며, 기타 수단은 제공되지 않습니다.</li>
            <li>결제금액은 서비스 페이지에 안내된 금액에 따릅니다.</li>
            <li>회사는 결제수단에 따라 별도의 수수료를 회원에게 부과하지 않습니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제11조 (요금 변경)</SmallTitle>
        <Text>
          <List2>
            <li>회사는 요금을 변경할 수 있으며, 변경 내용은 다음 결제 주기부터 적용됩니다.</li>
            <li>요금 인상 등 회원에게 불리한 변경의 경우 최소 30일 전, 그 외 변경은 최소 7일 전 고지합니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제12조 (청약철회 및 환불규정)</SmallTitle>
        <Text>
          <List2>
            <li>이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조에 따라 결제일로부터 7일 이내 청약철회를 요청할 수 있습니다.</li>
            <li>단, 다음의 경우 청약철회가 제한됩니다:
              <List>
                <li>서비스 이용이 개시된 경우 (디지털 콘텐츠 특성상 즉시 사용되는 경우)</li>
                <li>이용자의 사유로 서비스에 장애가 발생한 경우</li>
              </List>
            </li>
            <li>환불은 회사의 환불 정책에 따라 처리되며, 자세한 사항은 고객센터를 통해 안내됩니다.</li>
            <li>회사는 이용자의 청약철회 또는 계약 해제·해지 통보를 받은 경우 <Strong>3영업일 이내</Strong>에 대금을 환급합니다. 과오금이 발생한 경우에도 동일하며, 환급은 원결제수단으로 진행함을 원칙으로 합니다.</li>
            <li>회사는 「콘텐츠이용자보호지침」이 정한 환불 기준 및 절차를 준수합니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제13조 (개인정보보호)</SmallTitle>
        <Text>
          회사는 관련 법령 및 개인정보처리방침에 따라 회원의 개인정보를 보호합니다. 개인정보의 수집·이용 목적, 보유 및 이용기간, 파기 절차 및 방법 등은 별도의 개인정보처리방침에서 고지합니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>제14조 (회사의 의무)</SmallTitle>
        <Text>
          회사는 안정적인 서비스 제공을 위하여 최선을 다하며, 약관 또는 법령을 위반하지 않습니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>제15조 (회원의 의무)</SmallTitle>
        <Text>
          회원은 다음 행위를 하여서는 안 됩니다:
        </Text>
        <Text>
          <List>
            <li>타인의 정보 도용</li>
            <li>불법적 게시물 작성 또는 배포</li>
            <li>회사의 서비스 운영을 방해하는 행위</li>
            <li>자동화된 수단(scraping, crawling, bot 등)을 통한 데이터 수집</li>
            <li>서비스 내 정보를 리버스 엔지니어링, 복제, 판매 등 무단 상업적 이용</li>
            <li>불쾌하거나 불법적인 콘텐츠 배포</li>
            <li>회사의 사전 동의 없이 서비스를 무단 상업적 목적(재판매, 유사 플랫폼 제작 등)으로 활용하는 행위</li>
            <li>자신의 계정을 제3자와 공유하거나 타인에게 사용을 허락하는 행위</li>
          </List>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제16조 (저작권의 귀속 및 이용제한)</SmallTitle>
        <Text>
          <List2>
            <li>회원이 업로드한 콘텐츠의 저작권은 해당 회원에게 귀속됩니다.</li>
            <li>회원은 본인의 콘텐츠에 대해 제3자의 권리를 침해하지 않아야 하며, 침해 시 법적 책임은 회원에게 있습니다.</li>
            <li>회원이 사이트 관리 권한을 타인에게 위임한 경우(예: 부관리자), 해당 부관리자의 행위에 대한 책임은 회원 본인에게 있습니다.</li>
            <li>회원이 업로드한 게시물로 인해 발생한 모든 민·형사상 법적 책임은 회원에게 있으며, 회사는 이에 대해 어떠한 책임도 부담하지 않습니다.</li>
            <li>회원의 게시물이 타인의 권리를 침해하거나 관련 법령에 위반되는 경우, 회사는 사전 통지 없이 해당 게시물을 삭제하거나 임시조치(비공개 처리 등)를 취할 수 있습니다.</li>
            <li>회사는 회원이 게시한 콘텐츠를 사전 또는 상시적으로 검토할 의무가 없으며, 이로 인한 책임을 부담하지 않습니다.</li>
            <li>회사가 제공하는 웹사이트 템플릿, 디자인, UI 요소 등은 회사에 저작권이 있으며, 회원은 이를 복제하거나 외부로 전송, 배포, 상업적으로 이용할 수 없습니다.</li>
            <li>회원은 회사가 서비스를 제공·운영·보호하기 위한 범위 내에서, 회원이 업로드한 콘텐츠를 <Strong>저장, 복제, 수정(리사이즈 등 기술적 처리), 공중송신, 전시</Strong>할 수 있는 <Strong>비독점적·무상·국내외 이용허락</Strong>을 부여합니다. 회원은 언제든지 콘텐츠를 삭제함으로써 위 라이선스를 종료시킬 수 있으나, 서비스의 백업·보관, 분쟁 해결, 법령 준수 목적상 필요한 범위에서는 합리적인 기간 동안 보관될 수 있습니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제17조 (결제 자동 갱신 및 해제)</SmallTitle>
        <Text>
          <List2>
            <li>회원이 결제 시 "정기결제"를 선택한 경우, 서비스는 동일한 조건으로 자동 갱신되며, 회원이 직접 자동 결제를 해제하지 않는 한 정기적으로 결제가 이루어집니다.</li>
            <li>자동결제 해제는 서비스 내 설정 메뉴 또는 고객센터를 통해 언제든지 가능합니다.</li>
            <li>회사는 결제가 완료된 후 영수증 또는 결제 사실을 이메일 등으로 통지합니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제18조 (면책조항)</SmallTitle>
        <Text>
          <List2>
            <li>회사는 천재지변 등 불가항력으로 인한 서비스 제공 중단에 대하여 책임을 지지 않습니다.</li>
            <li>회원의 귀책사유로 인한 문제에 대해서는 회사가 책임지지 않습니다.</li>
            <li>회원이 유발한 과도한 트래픽으로 인한 장애 발생 시 회사는 해당 계정의 서비스 접속을 일시적으로 제한하거나 중단할 수 있습니다.</li>
            <li>회원의 인터넷 환경, 브라우저 설정, 디바이스 사양 등의 차이로 인해 발생하는 문제에 대해 회사는 책임을 지지 않습니다.</li>
          </List2>
        </Text>
      </Section>
      <Section>
        <SmallTitle>제19조 (서비스 가용성 보상)</SmallTitle>
        <Text>
          <List2>
            <li><Strong>장애 기준</Strong>: 불가항력 사유를 제외하고, 서비스 장애가 연속 3시간 이상 또는 월 누적 24시간 이상 발생한 경우.</li>
            <li><Strong>보상 범위</Strong>: 유료회원에게 장애 시간 1시간마다 1일 이용기간 연장 또는 동등한 크레딧을 제공합니다.</li>
            <li><Strong>신청 절차</Strong>: 회원은 장애 발생월의 말일로부터 30일 이내 고객센터로 신청해야 하며, 기한 경과 시 보상 청구권은 소멸됩니다.</li>
            <li><Strong>한도</Strong>: 보상은 해당 월 구독료를 한도로 하며, 현금 환급은 불가합니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제20조 (분쟁 해결)</SmallTitle>
        <Text>
          <List2>
            <li>회사는 분쟁 발생 시 신속하고 공정한 처리를 위해 노력합니다.</li>
            <li>회원이 제기한 정당한 의견이나 불만은 고객센터 등을 통해 처리됩니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제21조 (관할 법원 및 준거법)</SmallTitle>
        <Text>
          <List2>
            <li>본 약관과 관련한 분쟁은 대한민국 법을 준거법으로 하며, 회사와 회원 간 분쟁이 발생한 경우, 회사의 본사 소재지를 관할하는 법원을 제1심 관할법원으로 합니다.</li>
            <li>해외에 주소 또는 거소가 있는 회원의 경우, 서울중앙지방법원을 제1심 관할법원으로 합니다.</li>
            <li>회사는 해외에서 발생한 저작권 또는 서비스 이용과 관련된 분쟁에 대하여, 대한민국 법률 및 본 약관에 의거하여 대응할 수 있습니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제22조 (약관의 우선 적용)</SmallTitle>
        <Text>
          본 약관의 내용과 서비스 내 별도 안내, 공지사항, 개별 정책 등과 상충하는 경우에는 본 약관이 우선 적용됩니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>제23조 (손해배상 및 책임의 한계)</SmallTitle>
        <Text>
          <List2>
            <li>회사의 고의 또는 중대한 과실이 없는 한, 회사는 서비스 제공과 관련하여 회원에게 발생한 <Strong>통상손해</Strong>에 한하여 책임을 부담하며, 그 책임의 한도는 회원이 회사에 최근 <Strong>6개월간 지급한 이용요금(무료회원은 0원)</Strong>을 초과하지 않습니다.</li>
            <li>회사는 특별손해, 간접손해, 결과적 손해, 기대이익 손실 등에 대해 책임지지 않습니다.</li>
            <li>본 조항은 「약관의 규제에 관한 법률」 등 관련 법령에 의해 제한될 수 있으며, 그 제한 범위 내에서만 효력을 가집니다.</li>
          </List2>
        </Text>
      </Section>

      <Section>
        <SmallTitle>제24조 (약관의 해석)</SmallTitle>
        <Text>
          본 약관에서 정하지 아니한 사항은 관련 법령, 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 공정거래위원회 표준약관, 관계 법령 및 상관례에 따릅니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>제25조 (권리의 양도 금지)</SmallTitle>
        <Text>
          회원은 회사의 사전 서면 동의 없이 이 약관에 따른 권리 또는 의무를 제3자에게 양도, 위임, 담보 제공할 수 없습니다.
        </Text>
      </Section>

      <Section>
        <SmallTitle>제26조 (분리가능)</SmallTitle>
        <Text>
          본 약관의 일부 조항이 무효이거나 집행 불가능하더라도, 나머지 조항은 계속 유효합니다.
        </Text>
      </Section>
      <Text>
        본 약관은 2025년 8월 12일부터 적용됩니다.
      </Text>
    </>
  );
};

export default TermsKo;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_01};
  ${({ theme }) => theme.typography.Body_02_1};
  margin-bottom: 16px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

const SmallTitle = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_01};
  ${({ theme }) => theme.typography.Body_03_1};
  margin-bottom: 4px;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
  line-height: 1.4;
`;

const Strong = styled.strong`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
`;


const List = styled.ul`
  list-style: disc;
  padding-left: 14px;
`;

const List2 = styled.ol`
  list-style: decimal;
  padding-left: 14px;
`;